(function($) {

  var onSignedIn = function ( googleUser ) {
    var profile = googleUser.getBasicProfile();
    jQuery.ajax({
      data: {
        action: 'bs_google_login',
        user: {
          firstName: profile.getGivenName(),
          lastName: profile.getFamilyName(),
          email: profile.getEmail(),
        },
      },
    });
  };

  var onSignInRejected = function( response ) {
    popupClose();
  }

  var onInit = function ( auth2 ) {
    if ( !auth2.isSignedIn.get() ) {
      auth2.signIn().then(onSignedIn, onSignInRejected)
    } else {
      onSignedIn( auth2.currentUser.get() );
    }
  }

  var onError = function (error) {
    popupContent( error );
  }

  var initGoogleAuth = function() {
    popupLoading();

    gapi.load('auth2', function() {

      gapi.auth2.init({
        client_id: bellystream.google_app_client_id
      })
        .then(onInit, onError);
    });
  };

  $(document).on('click', '.doGoogleLogin', initGoogleAuth);

})(jQuery);

